module.exports = __webpack_public_path__ + "img/fj.3e230d8.svg";